// extracted by mini-css-extract-plugin
export default {"div":"NumberInputWithUnit_div__yLgt0","input":"NumberInputWithUnit_input__UrUKc","span":"NumberInputWithUnit_span__Caury"};